import { styled } from "theme/default/styled";

export const SHeaderLogo = styled.div<{ isFinOn?: boolean; isArabic?: boolean }>`
  width: ${({ isArabic }) => (isArabic ? "190px" : "119px")};
  height: ${({ isFinOn }) => (isFinOn ? "50px" : "38px")};
`;
